// @ts-nocheck
import Storage from "classes/Storage/Storage";

/**
 * Local keys that describe "who is logged in". The current account lives in
 * localStorage (shared between tabs), so sessionStorage.clear() alone leaves
 * the previous user's rights/settings/unread marks behind for the next login.
 * `Accounts` (the multi-account switcher list) is deliberately kept.
 */
export const SESSION_LOCAL_KEYS = ["token", "account", "Template"];

/** Purge every piece of state of the current user (logout / account switch) */
export default function clearSession() {
	try {
		sessionStorage.clear();
	} catch (e) {
		// storage blocked: nothing to clear
	}
	const local = new Storage(null, null, localStorage);
	SESSION_LOCAL_KEYS.forEach((key) => {
		try {
			local.removeItem(key);
		} catch (e) {
			// keep going: the other keys must still be purged
		}
	});
}
